import { PROJECTS } from "./profileData";
import { ArchitectureDiagram } from "./ArchitectureDiagram";
import { withDefaults } from "@/lib/sections";

export const ProjectsSection = ({ lang, content }) => (
  <section className="py-12" data-testid="projects-section">
    <p className="font-mono text-xs uppercase tracking-widest text-slate-500">// featured</p>
    <h2 className="mt-2 text-base font-semibold text-white md:text-lg" data-testid="projects-title">{withDefaults("p_projects", content)[`title_${lang}`]}</h2>
    <div className="mt-8 grid gap-6">
      {PROJECTS.map((p) => (
        <article
          key={p.id}
          className="flex flex-col rounded-2xl border border-white/10 bg-gradient-to-b from-[#0b2240] to-[#081B33] p-6"
          data-testid={`project-card-${p.id}`}
        >
          <span className="w-fit rounded-full border border-[#FF5500]/40 px-3 py-1 font-mono text-[11px] text-[#FF7A33]">
            {p.tag[lang]}
          </span>
          <h3 className="mt-4 text-xl font-semibold text-white">{p.title[lang]}</h3>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-400">{p.description[lang]}</p>
          <div className="mt-5 grid max-w-md grid-cols-2 gap-3">
            {p.metrics.map((m) => (
              <div key={m.value} className="rounded-lg bg-black/20 p-3">
                <p className="font-mono text-lg font-semibold text-[#FF5500]">{m.value}</p>
                <p className="text-xs text-slate-500">{m.label[lang]}</p>
              </div>
            ))}
          </div>
          <div className="mt-5 flex flex-wrap gap-2">
            {p.stack.map((s) => (
              <span key={s} className="font-mono text-xs text-sky-300">#{s}</span>
            ))}
          </div>
          <ArchitectureDiagram project={p} lang={lang} />
        </article>
      ))}
    </div>
  </section>
);

export default ProjectsSection;
